module.exports = __webpack_public_path__ + "assets/img/4610-mr.svg";